module.exports = __webpack_public_path__ + "img/havefun_title-ja.e67490aa.jpg";